// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AdminCallInfo_wrapper__2Vsgd","not-visible":"AdminCallInfo_not-visible__1xcCl","actions":"AdminCallInfo_actions__1wiMM","drag":"AdminCallInfo_drag__3LwY2"};